import React, { Fragment } from "react";
import { components } from "react-select";
import PropTypes from "prop-types";

const ValueContainer = ({ children, ...props }) => {
  return (
    <Fragment>
      {props.valueContainerLabel && (
        <components.ValueContainer {...props}>
          <span className="dropdown__placeholder">{props.valueContainerLabel}</span>
          <span className="dropdown__value">{children}</span>
        </components.ValueContainer>
      )}
      {!props.valueContainerLabel && <components.ValueContainer {...props}>{children}</components.ValueContainer>}
    </Fragment>
  );
};

ValueContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  valueContainerLabel: PropTypes.string
};

export default ValueContainer;



// WEBPACK FOOTER //
// ./src/components/Common/Form/FormDropdown/ValueContainer.js